module.exports = __webpack_public_path__ + "img/red.0a6016d7.png";